<template>
  <div>
    <div class="text-center bold banner">
      <p class="banner-title mb-0">SERVICIOS</p>
    </div>

    <div class="mt-5 mb-2 text-center">
      <p class="bold title title-space mt-3 mb-0">QUÉ OFRECEMOS</p>
      <b-img class="m-0 pt-0" src="../assets/img/icons/dobleline.png" alt="doble-line" />
    </div>

    <Cards />
    <Title :title="title01" :disable="false" />

    <b-container>
      <b-row>
        <b-col>
          <b-img
            fluid
            class="m-0 pt-0"
            src="../assets/img/icons/Mapa.png"
            alt="cobertura aduanal"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Cards from "../components/Cards";
import Title from "../components/Title";
export default {
  name: "Servicios",
  components: {
    Cards,
    Title,
  },
  metaInfo: {
    title: "Servicios Aduanales Integrales | Yonekawa y Asociados",
    meta: [
      { name: "Servicios", content: "Servicios" },
      { name: "Tramites", content: "COFEPRIS" },
    ],
  },
  data() {
    return {
      title01: "COBERTURA NACIONAL",
    };
  },
};
</script>
